import React, { useEffect } from 'react';
import './App.scss';
import Header from "./auth/Header";
import Footer from "./auth/Footer";
import IndexRoute from "./routes/IndexRoute";
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { persistReferralAddressFromEntry } from "./utils/referral";
import { persistAdsgramTrackingFromEntry } from "./utils/adsgram";

function App() {
    useEffect(() => {
        persistReferralAddressFromEntry();
        persistAdsgramTrackingFromEntry();
    }, []);

    return (
        <TonConnectUIProvider manifestUrl="https://cryptolotto777.com/tonconnect-manifest.json">
            <div className="App">
                <Header />
                <div className="app-content">
                    <IndexRoute />
                </div>
                <div className="app-footer-wrapper">
                    <Footer />
                </div>
            </div>
        </TonConnectUIProvider>
    );
}

export default App;
